import { render, staticRenderFns } from "./DiscountRequests.vue?vue&type=template&id=5feb22f6&"
import script from "./DiscountRequests.vue?vue&type=script&lang=js&"
export * from "./DiscountRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports